'use client';

import { useEffect, useRef } from 'react';

export default function VConsole() {
  const initialized = useRef(false);

  useEffect(() => {
    // 防止重复初始化
    if (initialized.current) return;

    // 立即检查 URL 参数
    const searchParams = new URLSearchParams(window.location.search);
    const enableDebug = searchParams.get('debug') === 'true' ||
                       searchParams.get('vconsole') === '1' ||
                       searchParams.get('vconsole') === 'true' ||
                       process.env.NODE_ENV === 'development'; // 开发环境默认启用

    if (enableDebug) {
      initialized.current = true;

      // 立即动态导入并初始化 VConsole
      import('vconsole').then((module) => {
        const VConsoleConstructor = module.default;

        // 检查是否已经存在 VConsole 实例
        if (!(window as any).vConsole) {
          const vConsoleInstance = new VConsoleConstructor({
            theme: 'dark',
            defaultPlugins: ['system', 'network', 'element', 'storage'],
            maxLogNumber: 2000,
            // 捕获所有日志
            onReady: () => {
              console.log('✅ VConsole 已启用 - 可以捕获所有错误日志');
            },
          });

          // 保存实例到 window 以便全局访问
          (window as any).vConsole = vConsoleInstance;

          // 拦截并记录未捕获的错误
          window.addEventListener('error', (event) => {
            console.error('🔴 Uncaught Error:', {
              message: event.message,
              filename: event.filename,
              lineno: event.lineno,
              colno: event.colno,
              error: event.error,
            });
          });

          // 拦截并记录未处理的 Promise 拒绝
          window.addEventListener('unhandledrejection', (event) => {
            console.error('🔴 Unhandled Promise Rejection:', {
              reason: event.reason,
              promise: event.promise,
            });
          });
        }
      }).catch((error) => {
        console.error('VConsole 加载失败:', error);
      });
    }
  }, []); // 空依赖数组，只在组件挂载时执行一次

  return null;
}
